import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import useAuthStore from "../../store/auth";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
function Logout() {
  const { t } = useTranslation();
  const { token, clearToken } = useAuthStore();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  useEffect(() => {
    queryClient.clear();
  }, []);
  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    setTimeout(clearToken(), 1000);
  });
  return <div>{t("Sign out")}</div>;
}
export default Logout;
